import { combineReducers } from 'redux';

import { START_OR_RESUME_SURVEY_SUCCESS, SUBMIT_ANSWER } from 'actionTypes';
import {
  byIdReducerTemplate,
  entityAllIdsReducerTemplate,
} from '../reducerUtils';

import { union } from 'lodash';

const standardByIdReducer = byIdReducerTemplate('answers');

function byIdReducer(state = {}, action) {
  switch (action.type) {
    case SUBMIT_ANSWER:
      return { ...state, ...action.answer };
    default:
      return standardByIdReducer(state, action);
  }
}

const standardAllIdsReducer = entityAllIdsReducerTemplate('answers');

function allIdsReducer(state = [], action) {
  switch (action.type) {
    case START_OR_RESUME_SURVEY_SUCCESS:
      return standardAllIdsReducer(state, action);
    case SUBMIT_ANSWER:
      return union(state, Object.keys(action.answer));
    default:
      return state;
  }
}

export default combineReducers({
  byId: byIdReducer,
  allIds: allIdsReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/entities/answerReducer.js